import { cn } from "../../../utils/cn";

const spacingWidthPercentage = 0.05;

export interface LoadingDotsProps {
  className?: string;
  height: number;
  dotClassName?: string;
}
export function LoadingDots({
  height,
  className,
  dotClassName,
}: LoadingDotsProps) {
  // width of each dot must match height for it to be circular
  dotClassName = dotClassName || "bg-gray-300";
  height = Number(height) || 10;
  const dotsTotalWidth = height * 3;

  // Given everything is percentage based, and each spacing between dots is 10%
  // we can calculate the total width by adding 20% to our total dots width.
  const width = `${dotsTotalWidth / (1 - spacingWidthPercentage * 2)}px`;
  return (
    <div
      className={cn("loading-dots", className)}
      style={{ width, height: `${height}px` }}
    >
      <div
        className={cn("loading-dots__dot loading-dots__dot1", dotClassName)}
      />
      <div className="loading-dots__spacer" />

      <div
        className={cn("loading-dots__dot loading-dots__dot2", dotClassName)}
      />

      <div className="loading-dots__spacer" />

      <div
        className={cn("loading-dots__dot loading-dots__dot3", dotClassName)}
      />
    </div>
  );
}
